var _defs, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBagnoletEx01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    "data-name": "Layer 4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 677 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-family: ArialMT, Arial;\n        font-size: 10.1px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #1d1d1b;\n      }\n\n      .cls-3, .cls-4 {\n        fill: none;\n      }\n\n      .cls-4 {\n        stroke: #9d9d9c;\n        stroke-width: .25px;\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -16.59,
    y: -3.84,
    width: 710.17,
    height: 1007.67
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 131.45,
    x2: 693.59,
    y2: 131.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 152.61,
    x2: 693.59,
    y2: 152.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 370.17,
    x2: 693.59,
    y2: 370.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 391.34,
    x2: 693.59,
    y2: 391.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 608.9,
    x2: 693.59,
    y2: 608.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 630.06,
    x2: 693.59,
    y2: 630.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 847.62,
    x2: 693.59,
    y2: 847.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 868.78,
    x2: 693.59,
    y2: 868.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 34.76,
    x2: 693.59,
    y2: 34.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 40.75,
    y1: -3.84,
    x2: 40.75,
    y2: 1003.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 122.92,
    y1: -3.84,
    x2: 122.92,
    y2: 1003.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 205.09,
    y1: -3.84,
    x2: 205.09,
    y2: 1003.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 287.27,
    y1: -3.84,
    x2: 287.27,
    y2: 1003.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 369.44,
    y1: -3.84,
    x2: 369.44,
    y2: 1003.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 451.61,
    y1: -3.84,
    x2: 451.61,
    y2: 1003.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 533.79,
    y1: -3.84,
    x2: 533.79,
    y2: 1003.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 615.96,
    y1: -3.84,
    x2: 615.96,
    y2: 1003.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 79.77,
    y1: -3.84,
    x2: 79.77,
    y2: 1003.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 161.95,
    y1: -3.84,
    x2: 161.95,
    y2: 1003.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 244.12,
    y1: -3.84,
    x2: 244.12,
    y2: 1003.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 326.29,
    y1: -3.84,
    x2: 326.29,
    y2: 1003.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 408.47,
    y1: -3.84,
    x2: 408.47,
    y2: 1003.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 490.64,
    y1: -3.84,
    x2: 490.64,
    y2: 1003.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 572.81,
    y1: -3.84,
    x2: 572.81,
    y2: 1003.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 654.99,
    y1: -3.84,
    x2: 654.99,
    y2: 1003.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 55.92,
    x2: 693.59,
    y2: 55.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 22.01,
    y1: -3.76,
    x2: 22.01,
    y2: 1003.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 104.19,
    y1: -3.76,
    x2: 104.19,
    y2: 1003.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 186.36,
    y1: -3.76,
    x2: 186.36,
    y2: 1003.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 268.53,
    y1: -3.76,
    x2: 268.53,
    y2: 1003.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 350.71,
    y1: -3.76,
    x2: 350.71,
    y2: 1003.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 432.88,
    y1: -3.76,
    x2: 432.88,
    y2: 1003.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 515.05,
    y1: -3.76,
    x2: 515.05,
    y2: 1003.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 597.23,
    y1: -3.76,
    x2: 597.23,
    y2: 1003.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 61.04,
    y1: -3.76,
    x2: 61.04,
    y2: 1003.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 143.21,
    y1: -3.76,
    x2: 143.21,
    y2: 1003.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 225.38,
    y1: -3.76,
    x2: 225.38,
    y2: 1003.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 307.56,
    y1: -3.76,
    x2: 307.56,
    y2: 1003.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 389.73,
    y1: -3.76,
    x2: 389.73,
    y2: 1003.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 471.9,
    y1: -3.76,
    x2: 471.9,
    y2: 1003.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 554.08,
    y1: -3.76,
    x2: 554.08,
    y2: 1003.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 636.25,
    y1: -3.76,
    x2: 636.25,
    y2: 1003.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 227.91,
    x2: 693.59,
    y2: 227.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 249.07,
    x2: 693.59,
    y2: 249.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 273.49,
    x2: 693.59,
    y2: 273.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 466.63,
    x2: 693.59,
    y2: 466.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 294.65,
    x2: 693.59,
    y2: 294.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 487.79,
    x2: 693.59,
    y2: 487.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 512.21,
    x2: 693.59,
    y2: 512.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 705.35,
    x2: 693.59,
    y2: 705.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 533.37,
    x2: 693.59,
    y2: 533.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 726.52,
    x2: 693.59,
    y2: 726.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 750.93,
    x2: 693.59,
    y2: 750.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 944.08,
    x2: 693.59,
    y2: 944.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 772.09,
    x2: 693.59,
    y2: 772.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: -16.59,
    y1: 965.24,
    x2: 693.59,
    y2: 965.24
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.95,131.34h-20.09V55.71h20.09v75.63ZM21.8,34.55v214.54l19.06.19v-96.79h20.09v96.79h19.03V34.74l-58.18-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.13,131.24h-20.12V56.14h20.12v75.1ZM143.13,228.12h-20.12v-75.3h20.12v75.3ZM103.97,249.28h58.18V34.55h-58.18v214.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "244.33 55.71 244.33 34.55 186.15 34.55 186.15 249.28 244.33 249.28 244.33 228.12 205.18 228.12 205.18 55.71 244.33 55.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M297.6,228.12h-10.24V55.71h10.25l10.25,86.32-10.26,86.09ZM268.32,249.28h58.18V34.55h-58.18v214.73Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "408.68 55.71 408.68 34.55 350.5 34.55 350.5 249.28 408.68 249.28 408.68 228.12 369.52 228.12 369.52 152.4 408.68 152.4 408.68 131.61 369.52 131.61 369.52 55.71 408.68 55.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "490.85 55.71 490.85 34.55 432.67 34.55 432.67 249.28 451.7 249.28 451.7 152.4 490.85 152.4 490.85 131.52 451.7 131.52 451.7 55.71 490.85 55.71"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "541.14 156.83 541.14 173.09 553.87 173.09 553.87 228.12 533.87 228.12 533.87 196.07 533.87 173.09 533.87 156.83 533.87 152.31 533.87 152.19 533.87 144.6 533.87 131.52 533.87 129.07 533.87 55.71 553.97 55.71 553.97 131.24 573.02 131.24 573.02 34.55 514.84 34.55 514.84 249.28 573.02 249.28 573.02 152.8 541.14 152.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "636.21 34.55 636.21 131.52 616.04 131.52 616.04 34.55 597.02 34.55 597.02 249.28 616.04 249.28 616.04 152.37 636.17 152.37 636.17 249.28 655.2 249.28 655.2 34.55 636.21 34.55"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.5,
    y: 273.28,
    width: 20.79,
    height: 214.73
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.15 273.27 143.15 387 143.15 416.68 143.15 466.84 123.13 466.84 123.13 416.68 103.98 416.68 103.98 488 162.16 488 162.16 273.27 143.15 273.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "234.06 273.27 205.18 370.25 205.18 273.27 186.15 273.27 186.15 488 205.18 488 205.18 391.03 234.06 488 244.33 488 244.33 273.27 234.06 273.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "287.35 466.84 287.35 273.27 268.32 273.27 268.32 488 326.5 488 326.5 466.84 287.35 466.84"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M395.17,488h-9.85l9.85-96.46v96.46ZM364.81,488v-96.46l9.85,96.46h-9.85ZM398.65,273.27l-19.07,61.81-18.76-61.81h-10.33v214.73h58.18v-214.73h-10.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "471.85 273.27 471.85 369.96 466.57 369.96 442.34 273.27 432.67 273.27 432.67 488 451.7 488 451.7 391.55 456.88 391.55 480.71 488 490.85 488 490.85 273.27 471.85 273.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M554.02,466.84h-20.2v-172.2h20.2v172.2ZM514.84,488h58.18v-214.73h-58.18v214.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M635.96,370.35h-19.7v-75.91h19.7v75.91ZM597.02,273.27v214.73h19.24v-96.88h38.94v-117.85h-58.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M143.12,608.69h-19.9v-75.53h19.9v75.53ZM103.98,512v214.73h19.16v-96.46l28.88,96.46h10.14v-214.73h-58.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "244.33 533.16 244.33 512 186.15 512 186.15 629.85 225.09 629.85 225.09 705.57 186.15 705.57 186.15 726.51 244.33 726.51 244.33 609.11 205.15 609.11 205.15 533.16 244.33 533.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "326.42 533.16 326.5 512 268.32 512 268.24 533.16 287.48 533.16 287.48 726.51 307.45 726.51 307.37 533.16 326.42 533.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "389.63 512 389.63 705.57 369.52 705.57 369.52 512 350.5 512 350.5 726.51 408.68 726.51 408.68 512 389.63 512"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "480.69 512 470.59 705.57 451.9 705.57 442.82 512 432.67 512 432.67 726.73 490.85 726.73 490.85 512 480.69 512"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "562.87 512 558.1 705.57 548.27 705.57 546.1 609.11 541.55 609.11 539.16 705.57 529.34 705.57 525 512 514.84 512 514.84 726.51 573.02 726.51 573.02 512 562.87 512"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "644.93 512 636.04 608.69 616.17 608.69 607.28 512 597.02 512 597.02 726.73 607.21 726.73 616.17 630.27 636.04 630.27 645.01 726.73 655.2 726.73 655.2 512 644.93 512"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "79.98 771.88 79.98 750.72 55.97 750.72 53.41 779.6 48.14 779.6 45.81 750.72 21.8 750.72 21.8 771.88 40.96 771.88 40.96 965.45 60.83 965.45 60.83 771.88 79.98 771.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "122.98 944.29 162.16 785.01 162.16 750.72 103.97 750.72 103.97 771.88 143.15 771.88 103.97 920.25 103.97 965.45 162.16 965.45 162.16 944.29 122.98 944.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.74,684.69h-19.7v-151.53h19.7v151.53ZM21.8,512v193.15h19.16v21.58h19.87v-21.58h19.16v-193.15H21.8Z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(476.88 965.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(1) Premi\xE8re exploration typographique."))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagnoletEx01);
export default __webpack_public_path__ + "static/media/bagnoletEx-01.aa9f5cb6d00eb3f44cbfcebb4cf3077a.svg";
export { ForwardRef as ReactComponent };